module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.number > 0),
      expression: "number > 0"
    }],
    staticClass: "text-center clear m-t"
  }, [_c('router-link', {
    staticClass: "btn btn-sm btn-border text-normal btn-rounded",
    attrs: {
      "to": {
        name: 'user_message'
      }
    }
  }, [_vm._v(_vm._s(_vm.number) + "条新消息")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f44df24"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/feed/new-message.vue
// module id = 271
// module chunks = 107